import { combinedApi as api } from '@redux/combinedApi';
export const addTagTypes = ['Trend'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getTrendGetTrendValues: build.query<GetTrendGetTrendValuesApiResponse, GetTrendGetTrendValuesApiArg>({
        query: (queryArg) => ({
          url: `/Trend/get-trend-values`,
          params: {
            measurementDeviceId: queryArg.measurementDeviceId,
            categoryPathWithoutPhase: queryArg.categoryPathWithoutPhase,
          },
        }),
        providesTags: ['Trend'],
      }),
      getTrendGetTrendResultsCount: build.query<
        GetTrendGetTrendResultsCountApiResponse,
        GetTrendGetTrendResultsCountApiArg
      >({
        query: (queryArg) => ({
          url: `/Trend/get-trend-results-count`,
          params: {
            trendJobId: queryArg.trendJobId,
            valueThreshold: queryArg.valueThreshold,
            increaseThreshold: queryArg.increaseThreshold,
            increaseDurationThreshold: queryArg.increaseDurationThreshold,
            averageIncreaseThreshold: queryArg.averageIncreaseThreshold,
          },
        }),
        providesTags: ['Trend'],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as trendJobApi };
export type GetTrendGetTrendValuesApiResponse =
  /** status 200 OK */ ApiApplicationServicesDataTypesTrendTypesTrendValuesPerMeasurementParameter[];
export type GetTrendGetTrendValuesApiArg = {
  measurementDeviceId?: number;
  categoryPathWithoutPhase?: string;
};
export type GetTrendGetTrendResultsCountApiResponse =
  /** status 200 OK */ ApiApplicationServicesDataTypesTrendTypesTrendResultsCount[];
export type GetTrendGetTrendResultsCountApiArg = {
  trendJobId?: number;
  valueThreshold?: number;
  increaseThreshold?: number;
  increaseDurationThreshold?: number;
  averageIncreaseThreshold?: number;
};
export type ApiApplicationServicesDataTypesTrendTypesTrendValue = {
  weekStart?: string;
  value?: number | null;
};
export type ApiApplicationServicesDataTypesTrendTypesTrendValuesPerMeasurementParameter = {
  measurementParameterId?: number;
  trendValues?: ApiApplicationServicesDataTypesTrendTypesTrendValue[] | null;
};
export type ApiApplicationServicesDataTypesTrendTypesTrendResultsCount = {
  measurementDeviceId?: number;
  measurementParameterCategoryWithoutPhase?: string | null;
  numberOfTrends?: number;
};
export const {
  useGetTrendGetTrendValuesQuery,
  useLazyGetTrendGetTrendValuesQuery,
  useGetTrendGetTrendResultsCountQuery,
  useLazyGetTrendGetTrendResultsCountQuery,
} = injectedRtkApi;
